export function createTimerDisplay(scene) {

    const width = scene.cameras.main.width;

    const badgeWidth = 96;
    const badgeHeight = 28;

    const x = width * 0.73;

    /*
     * Original timer position.
     */
    const timerY = 183;

    /*
     * When both timer and moves are active,
     * moves sits slightly above the timer.
     */
    const movesY = timerY - 36;

    /*
     * -----------------------------------------
     * TIMER
     * -----------------------------------------
     */

    if (scene.userTimer) {

        const timerDisplay =
            createCounterBadge(
                scene,
                x,
                timerY,
                'timer'
            );

        scene.timerText =
            timerDisplay.text;

        scene.timerDisplayBackground =
            timerDisplay.background;

        scene.timerDisplayClockBackground =
            timerDisplay.clockBackground;

        scene.timerDisplayIcon =
            timerDisplay.clock;

        if (scene.remainingTime == null) {
            scene.remainingTime =
                scene.startTime;
        }
    }


    /*
     * -----------------------------------------
     * MOVES
     * -----------------------------------------
     */

    if (scene.limitedMoves) {

        /*
         * If both are enabled, moves goes
         * above the timer.
         *
         * If only moves are enabled, moves
         * takes the timer's original position.
         */
        const y =
            scene.userTimer
                ? movesY
                : timerY;

        const movesDisplay =
            createCounterBadge(
                scene,
                x,
                y,
                'moves'
            );

        scene.movesText =
            movesDisplay.text;

        scene.movesDisplayBackground =
            movesDisplay.background;

        scene.movesDisplayClockBackground =
            movesDisplay.clockBackground;

        scene.movesDisplayIcon =
            movesDisplay.clock;
    }

    updateTimerDisplay(scene);
}


function createCounterBadge(
    scene,
    x,
    y,
    type
) {

    const badgeWidth = 96;
    const badgeHeight = 28;

    /*
     * Pink badge background.
     *
     * This is the same container used
     * by the existing timer.
     */
    const background =
        scene.add.graphics();

    background.fillStyle(
        0xF48DBC,
        1
    );

    background.fillRoundedRect(
        x - badgeWidth / 2,
        y - badgeHeight / 2,
        badgeWidth,
        badgeHeight,
        badgeHeight / 2
    );

    background.setDepth(50);


    /*
     * White circular area.
     *
     * Kept exactly like the existing timer.
     */
    const clockBackground =
        scene.add.graphics();

    clockBackground.fillStyle(
        0xFFFFFF,
        1
    );

    clockBackground.fillCircle(
        x + 35,
        y,
        20
    );

    clockBackground.setDepth(51);


    /*
     * Existing clock image.
     *
     * We keep the same image so the visual
     * treatment stays consistent.
     */
    const clock =
        scene.add.image(
            x + 35,
            y,
            'clockIcon'
        );

    clock
        .setOrigin(0.5)
        .setDepth(51);

    clock.setDisplaySize(
        42,
        42
    );


    /*
     * Counter text.
     */
    const text =
        scene.add.text(
            x - 15,
            y,
            '',
            {
                fontFamily: 'paytoneone',
                fontSize: '20px',
                color: '#FFFFFF'
            }
        );

    text
        .setOrigin(0.5)
        .setDepth(51);


    return {
        background,
        clockBackground,
        clock,
        text
    };
}


export function updateTimerDisplay(scene) {

    /*
     * -----------------------------------------
     * TIMER
     * -----------------------------------------
     */

    if (
        scene.userTimer &&
        scene.timerText
    ) {

        const minutes =
            Math.floor(
                scene.remainingTime / 60
            );

        const seconds =
            scene.remainingTime % 60;

        const formattedSeconds =
            seconds < 10
                ? '0' + seconds
                : seconds;

        scene.timerText.setText(
            `${minutes}:${formattedSeconds}`
        );
    }


    /*
     * -----------------------------------------
     * MOVES
     * -----------------------------------------
     */

    if (
        scene.limitedMoves &&
        scene.movesText
    ) {

        scene.movesText.setText(
            `${Math.max(
                scene.numberOfMovesRemaining,
                0
            )}`
        );
    }
}